<script lang="ts">
  import { confirmDelete, notification } from "/shared/utils.js";
  import { formatDate } from "../utils";
  import { deletePost } from "../api.js";
  import { updates } from "../stores.js";

  export let update;
  export let edit = false;

  const onDelete = () =>
    deletePost(update.pk)
      .then(() => {
        // Remove update from store
        $updates = $updates.filter((_update) => update.pk !== _update.pk);
      })
      .catch((error) => {
        notification.reportError(error);
      });
</script>

<style>
  .card-title {
    text-transform: uppercase;
    margin: 0;
    font-size: 1.5rem;
  }
  .card-img-top {
    height: 300px;
  }
</style>

<div class="py-3">
  {#if update.image_uuid}
    <div class="text-white border-0 gradient-overlay overflow-hidden mx-auto w-100">
      <img class="card-img-top" data-blink-uuid={update.image_uuid} alt={update.name} />
      <div
        class="card-img-overlay d-flex align-items-end justify-content-start
        pb-1">
        <div class="overlay-content">
          <h5 class="card-title font-weight-normal mb-0">
            {@html formatDate(update.created)}
          </h5>
        </div>
      </div>
    </div>
  {:else}
    <div class="text-left">
      <h5 class="card-title font-weight-normal">
        {@html formatDate(update.created)}
      </h5>
    </div>
  {/if}
  <div
    class="text-muted mb-0"
    class:mt-4={update.image_link}
    class:mt-2={!update.image_link}>
    <p style="white-space: pre-wrap;">{update.body}</p>
  </div>
  {#if edit}
    <div
      class="btn btn-outline-danger btn-sm px-3 text-right"
      on:click={() => confirmDelete("update", onDelete)}>
      Delete
    </div>
  {/if}
</div>
